import { render, staticRenderFns } from "./CreateBread.vue?vue&type=template&id=bfdb5f68"
import script from "./CreateBread.vue?vue&type=script&lang=js"
export * from "./CreateBread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports